import React from "react";
import { CellContext } from "@tanstack/react-table";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../ui/dropdown-menu";
import { AppContext } from "@/App";
import { PageLockContext } from "@/Components/PageLockProvider";

export const WorkPackageCell = ({ getValue, row: { index }, column: { id }, table }: CellContext<any, unknown>) => {
    const app = React.useContext(AppContext);
    const lock = React.useContext(PageLockContext);
    const editingEnabled = app.applicationUser?.userSettings?.inlineTableEditing ?? false;

    const initialWPName = getValue();

    // We need to keep and update the state of the cell normally
    const [selectedWPName, setSelectedWPName] = React.useState(initialWPName)

    // When the input is blurred, we'll call our table meta's updateData function
    const onBlur = (workPackageName: string, workPackageId: number) => {
        setSelectedWPName(workPackageName);

        table.options.meta?.updateData(index, id, workPackageName)
        table.options.meta?.updateData(index, "workPackageId", workPackageId);
    }

    // If the initialValue is changed external, sync it up with our state
    React.useEffect(() => {
        setSelectedWPName(initialWPName)
    }, [initialWPName])

    if (app.authLevel !== 3 && !lock.viewOnly && editingEnabled) { // only allow editing for non-viewers
        return (
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <button className="w-full text-center">
                        {selectedWPName as string || "Select a work package"}
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-[200px]">
                    {app.workPackageOptions?.[0]?.workPackageNames?.map((wp) => (
                        <DropdownMenuItem
                            key={wp.workPackageId}
                            onClick={() => {
                                onBlur(wp.workPackageName, wp.workPackageId);
                            }}>
                            <div className="text-center">{wp.workPackageName}</div>
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>
        );
    }
    return <div className="text-center">{selectedWPName as string}</div>
}